var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseActivity',{attrs:{"heading":_vm.heading,"slideTo":_vm.level}},_vm._l((_vm.stages),function(item){return _c('SwiperSlide',{key:item.title},[_c('QuestCard',_vm._b({attrs:{"questLink":_vm.questLink(item)}},'QuestCard',item,false))],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }